import React from "react";
import { Phone, Mail, Clock, MessageCircle, MapPin } from "lucide-react";
import { Reveal } from "../components/site/Layout";
import { company } from "../data/mock";

const infoCards = [
  {
    icon: Phone,
    title: "Telefon",
    testId: "contact-phone",
    content: (
      <a href={`tel:${company.phoneHref}`}>{company.phone}</a>
    ),
  },
  {
    icon: Mail,
    title: "Email",
    testId: "contact-email",
    content: (
      <a href={`mailto:${company.email}`} className="email-link">
        {company.email}
      </a>
    ),
  },
  {
    icon: MessageCircle,
    title: "WhatsApp",
    testId: "contact-whatsapp",
    content: (
      <a
        href={`https://wa.me/${company.whatsapp}`}
        target="_blank"
        rel="noreferrer"
      >
        Scrie-ne pe WhatsApp
      </a>
    ),
  },
  {
    icon: MapPin,
    title: "Adresă",
    testId: "contact-address",
    content: <p>{company.address}</p>,
  },
  {
    icon: Clock,
    title: "Program",
    testId: "contact-schedule",
    content: <p>{company.schedule}</p>,
  },
];

const Contact = () => {
  return (
    <>
      <section className="page-hero">
        <div className="site-container">
          <h1>Contact</h1>
          <p>
            Cel mai rapid canal este telefonul. Pentru mesaje sau
            documente, funcționează la fel de bine WhatsApp-ul sau
            email-ul. Răspundem în timp util, direct.
          </p>
        </div>
      </section>

      <section className="section" style={{ paddingBottom: 48 }}>
        <div className="site-container">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: 20,
            }}
          >
            {infoCards.map((c, i) => {
              const Icon = c.icon;
              return (
                <Reveal key={c.title} delay={i * 100}>
                  <div className="contact-info-card" data-testid={c.testId}>
                    <div className="contact-info-icon">
                      <Icon size={21} />
                    </div>
                    <div>
                      <h4>{c.title}</h4>
                      {c.content}
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 32 }}>
        <div className="site-container">
          <Reveal>
            <div className="cta-band" data-testid="contact-cta-band">
              <h2>O discuție inițială de 15 minute</h2>
              <p>
                Un scurt apel telefonic în care înțelegem situația
                actuală și evaluăm împreună dacă putem contribui. Fără
                costuri, fără angajament.
              </p>
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  justifyContent: "center",
                  flexWrap: "wrap",
                  marginTop: 8,
                }}
              >
                <a
                  href={`tel:${company.phoneHref}`}
                  className="btn-teal"
                  data-testid="contact-call-btn"
                >
                  <Phone
                    size={15}
                    style={{
                      display: "inline",
                      marginRight: 8,
                      verticalAlign: "-2px",
                    }}
                  />
                  {company.phone}
                </a>
                <a
                  href={`mailto:${company.email}`}
                  className="btn-accent"
                  data-testid="contact-email-btn"
                >
                  <Mail
                    size={15}
                    style={{
                      display: "inline",
                      marginRight: 8,
                      verticalAlign: "-2px",
                    }}
                  />
                  Trimite email
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="site-container" style={{ maxWidth: 720 }}>
          <Reveal>
            <div
              style={{
                textAlign: "center",
                color: "var(--ce-muted)",
                fontSize: "0.95rem",
                lineHeight: 1.7,
              }}
            >
              <p style={{ marginBottom: 6 }}>
                <strong style={{ color: "var(--ce-heading)" }}>
                  {company.legalName}
                </strong>
              </p>
              <p>CUI: {company.cui}</p>
              <p>Nr. Reg. Com.: {company.regCom}</p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default Contact;
